module.exports = __webpack_public_path__ + "static/linkedin_icon-b12bcfbd152c634603ef0e66a5fb09cc.png";